import React from 'react';

const HoursSelector = ({ hours, selectedTime, onHoursChange }) => {
  const endHour = selectedTime 
    ? String(parseInt(selectedTime.split(':')[0]) + hours).padStart(2, '0') 
    : '00';

  return (
    <div id="hours-selector">
      <label className="text-[#FFCC00] text-sm font-semibold uppercase tracking-wider mb-3 block">
        Durata (ore)
      </label>
      <div className="flex items-center gap-4">
        <button
          onClick={() => onHoursChange(Math.max(1, hours - 1))}
          className="w-12 h-12 bg-[#0A0A0A] border border-[#2A2A2A] text-white hover:border-[#FFCC00] transition-colors text-xl font-bold"
          data-testid="hours-decrease"
        >
          -
        </button>
        <span className="text-white text-2xl font-bold w-16 text-center" data-testid="hours-value">
          {hours}
        </span>
        <button
          onClick={() => onHoursChange(Math.min(17, hours + 1))}
          className="w-12 h-12 bg-[#0A0A0A] border border-[#2A2A2A] text-white hover:border-[#FFCC00] transition-colors text-xl font-bold"
          data-testid="hours-increase"
        >
          +
        </button>
        <span className="text-gray-400 text-sm">
          Fino alle {endHour}:00
        </span>
      </div>
    </div>
  );
};

export default HoursSelector;
